import React, { useMemo } from 'react';
import { DealType, DealTypeToId } from 'constants/deals';
import { InferType } from 'yup';
import { dealInputSchema } from './inputSchema';

export type IDealFormData = InferType<typeof dealInputSchema>;

const initialDealFormData: IDealFormData = {
    dealTypeId: DealTypeToId[DealType.Acquisition],
    dealName: 'First Deal',
    address: '',
    acquisitionPrice: 0,
    city: '',
    county: '',
    state: '',
    zipCode: '',
    latitude: undefined,
    longitude: undefined,
    useCoordinates: false,
    market_id: '',
    constructionTypeId: '',
};

export const useDealForm = (dealFormData?: IDealFormData) => {
    const [formData, setFormData] = React.useState<IDealFormData>(dealFormData || initialDealFormData);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    ) => {
        const { name, value, type } = e.target;
        const checked = type === 'checkbox' && (e.target as HTMLInputElement).checked;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const isFormValid = useMemo(() => dealInputSchema.isValidSync(formData), [formData]);

    return {
        formData,
        setFormData,
        isFormValid,
        handleChange,
    };
};
